import angular from 'angular';

class modalImportCommunityMemershipCtrl {
    /*@ngInject*/
    constructor($translate, CONF, logger, CommunitySvc) {
        this.$translate = $translate;
        this.CONF = CONF;
        this.CommunitySvc = CommunitySvc;
        this.logger = logger;
    }

    $onInit() {
        this.title = 'community.import.title';
        this.hasUpdate = false;
        this.includes = {
            errorMessages: require('../layouts/error-messages.html'),
        };
        this.criteria = {};

        // Affichage des étapes de l'import
        this.displayForm = false;
        this.displayLoad = false;
        this.displayResult = false;

        this.manageDisplay('form');
    }

    importCsv() {
        if (this.form.$valid) {
            this.manageDisplay('load');

            this.CommunitySvc.importMembers(this.criteria).then(
                result => {
                    this.progressTitle = this.$translate.instant('community.import.progress');
                    this.displayProgress = true;
                    this.taskId = result.data;
                    this.title = 'community.import.result_title';
                },
                () => {
                    this.criteria.file = null;
                    this.logger.error('error.import');
                    this.manageDisplay('form');
                }
            );
        }
    }

    onTaskEnd(results) {
        this.displayProgress = false;
        if (results) {
            var report = results.result;
            this.CommunitySvc.getReportWithLink(report);
            this.manageDisplay('result');
            this.report = report;
            this.hasUpdate = true;
            this.communityName = report.additionalParams['COMMUNITY_NAME'];
            this.nbCompanyMembers = report.create + report.update;
        }
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }

    ok() {
        this.modalInstance.close(this.hasUpdate);
    }

    manageDisplay(step) {
        switch (step) {
            case 'form':
                this.displayForm = true;
                this.displayLoad = false;
                this.displayResult = false;
                break;
            case 'load':
                this.displayForm = false;
                this.displayLoad = true;
                this.displayResult = false;
                break;
            case 'result':
                this.displayForm = false;
                this.displayLoad = false;
                this.displayResult = true;
                break;
        }
    }
}

angular.module('app.principal').component('modalImportCommunityMemership', {
    templateUrl: require('./modal-import-community-membership.html'),
    controller: modalImportCommunityMemershipCtrl,
    bindings: {
        modalInstance: '<',
    },
});
